import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { dashboardFichasAPI } from '../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import '../Clientes.css';

const SECTION_LABELS = {
  clientes: 'Clientes',
  proveedores: 'Proveedores',
  empleados: 'Empleados',
  fondos: 'Fondos',
};

const SECTION_ROOT_PATH = {
  clientes: '/clientes',
  proveedores: '/proveedores',
  empleados: '/empleados',
  fondos: '/movimientos-fondos',
};

const DashboardFichas = ({ origen }) => {
  const [fichas, setFichas] = useState([]);
  const [loading, setLoading] = useState(true);
  const { hasPermission } = useAuth();
  const basePath = origen ? `/${origen}/fichas` : '/dashboard-fichas';
  const sectionLabel = origen ? SECTION_LABELS[origen] || origen : null;
  const sectionRoot = origen ? SECTION_ROOT_PATH[origen] : null;

  useEffect(() => {
    loadFichas();
  }, [origen]);

  const loadFichas = async () => {
    try {
      setLoading(true);
      const params = origen ? { origen } : {};
      const response = await dashboardFichasAPI.listar(params);
      if (response.success) {
        setFichas(response.data || []);
      }
    } catch (error) {
      toast.error(error.message || 'Error al cargar fichas');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Eliminar esta ficha del dashboard?')) return;
    try {
      const response = await dashboardFichasAPI.eliminar(id);
      if (response.success) {
        toast.success('Ficha eliminada');
        loadFichas();
      }
    } catch (error) {
      toast.error(error.message || 'Error al eliminar');
    }
  };

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  return (
    <div className="clientes pagina-listado pagina-listado--scroll">
      <div className="page-header">
        <h1>{sectionLabel ? `Fichas de ${sectionLabel}` : 'Fichas del Dashboard'}</h1>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          <Link to={origen ? sectionRoot : '/dashboard'} className="btn-secondary">
            {origen ? `Volver a ${sectionLabel}` : 'Ver Dashboard'}
          </Link>
          {hasPermission('ver_informes') && (
            <Link to={`${basePath}/nuevo`} className="btn-primary">+ Nueva Ficha</Link>
          )}
        </div>
      </div>

      <div className="pagina-listado-fijo">
        <p className="page-description">
          {sectionLabel
            ? `Cree y edite fichas (métricas) de ${sectionLabel.toLowerCase()} que se muestran en el dashboard.`
            : 'Cree y edite fichas (métricas) que se muestran en el dashboard.'}
        </p>
      </div>

      <div className="listado-panel clientes-listado listado-controles">
        <div className="listado-panel-cuerpo clientes-listado-cuerpo">
          <div className="listado-tabla-area clientes-listado-tabla-area">
            <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Título</th>
              <th>Origen</th>
              <th>Operación</th>
              <th>Métrica</th>
              <th>En dashboard</th>
              <th>Activo</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {fichas.length === 0 ? (
              <tr>
                <td colSpan="7" className="no-data">No hay fichas. Cree una para verla en el dashboard.</td>
              </tr>
            ) : (
              fichas.map((f) => (
                <tr key={f.id}>
                  <td><strong>{f.titulo}</strong></td>
                  <td>{f.origen || '-'}</td>
                  <td>{f.operacion || '-'}</td>
                  <td><code>{f.clave_metrica}</code></td>
                  <td>
                    <span className={`badge ${f.mostrar_en_dashboard ? 'activo' : 'inactivo'}`}>
                      {f.mostrar_en_dashboard ? 'Sí' : 'No'}
                    </span>
                  </td>
                  <td>
                    <span className={`badge ${f.activo ? 'activo' : 'inactivo'}`}>
                      {f.activo ? 'Sí' : 'No'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      {hasPermission('ver_informes') && (
                        <>
                          <Link to={`${basePath}/editar/${f.id}`} className="btn-edit">Editar</Link>
                          <button type="button" onClick={() => handleDelete(f.id)} className="btn-delete">Eliminar</button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardFichas;
